<div class="corePageLayout">

  @if(isError404) {
    <div class="info-layout">
      <div class="title">
        <h1 class="titleText">An error has occured!</h1>
      </div>
      <!--
      <div class="error-code-display">
        error code: 404
      </div>
      -->
      <div class="title-description">
        Page not found
      </div>
      <div class="description">
        the page you are looking for does not exist. it might have been moved or deleted
      </div>
    </div>
  }
  
  @if(isError504) {
    <div class="info-layout">

      @if(tenant && imagePath) {
        <!-- this will display the local image-->
        <div class="logoframe">
          <img class="imgs" [src]="imagePath">
        </div>
      }
      

      <!--
      <div class="title">
        <h1 class="titleText">An error has occured!</h1>
      </div>
      -->

      <!--
      <div class="error-code-display">
        error code: 504 
      </div>
      -->
      <div class="title-description">
        {{ 'ErrorPage.TitleServerConnectionError' | translate }}
      </div>
      <div class="description">
        {{ 'ErrorPage.DescriptionServerConnectionError' | translate }}
      </div>
    </div>


    <!--
    We’re having trouble connecting to our servers right now.

Please check your internet connection or try again in a few moments. If the issue persists, our team is already working to resolve it.

Thank you for your patience.



Nous rencontrons actuellement des difficultés pour nous connecter à nos serveurs.

Veuillez vérifier votre connexion Internet ou réessayer dans quelques instants. Si le problème persiste, notre équipe travaille déjà à sa résolution.

Merci de votre patience.
    
    -->
  }
  
</div>